import React from 'react'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import useStyles from './styles'

const ConfirmValidationDialog = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false)
  }

  const classes = useStyles()

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Atenção: Revise o texto do seu documento"
      closeButtonAction=""
      closeButtonText="Prosseguir"
      actionButton={handleClose}
      dialogSize="md"
      preventCloseOnBackdropClick={true}
    >
      <Box mb={2}>
        <Typography variant="body1" paragraph>
          Alguns documentos exigem atenção especial em determinados trechos que
          devem ser{' '}
          <strong>personalizados conforme a realidade da sua empresa</strong>,
          seus processos e práticas internas.
        </Typography>

        <Box className={classes.cardInfo} mb={2}>
          <Typography variant="body1">
            Esses pontos serão{' '}
            <strong>
              sinalizados em <i>itálico</i>
            </strong>{' '}
            pelo Encarregado de Dados e devem ser revisados com cuidado.
          </Typography>
        </Box>

        <Typography variant="body1" paragraph>
          Antes de prosseguir,{' '}
          <strong>
            verifique se todas as informações refletem corretamente a sua
            operação
          </strong>
          . Caso o modelo não esteja de acordo,{' '}
          <strong>faça os ajustes necessários.</strong>
        </Typography>

        <Typography variant="body1">
          Lembre-se: a responsabilidade pelo preenchimento e pela veracidade das
          informações é da sua empresa.
        </Typography>
      </Box>
    </BaseDialog>
  )
}

export default ConfirmValidationDialog
